import type { PartnerMatchingLanguage } from '@houzy/schemas/partner-management';

import type { EmployeeRange } from './types';

export const EMPLOYEE_LABEL_KEYS: Record<EmployeeRange, string> = {
    '1-5': 'SETTINGS.COMPANY.PROFILE.EMPLOYEES_1_5',
    '6-20': 'SETTINGS.COMPANY.PROFILE.EMPLOYEES_6_20',
    '21-50': 'SETTINGS.COMPANY.PROFILE.EMPLOYEES_21_50',
    '51-200': 'SETTINGS.COMPANY.PROFILE.EMPLOYEES_51_200',
    '201+': 'SETTINGS.COMPANY.PROFILE.EMPLOYEES_201_PLUS',
};

export const MATCHING_LANGUAGE_LABEL_KEYS: Record<PartnerMatchingLanguage, string> = {
    de: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.DE',
    fr: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.FR',
    en: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.EN',
    it: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.IT',
    sq: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.SQ',
    sr: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.SR',
    hr: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.HR',
    tr: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.TR',
    pt: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.PT',
    es: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.ES',
    ro: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.RO',
    other: 'SETTINGS.COMPANY.CRITERIA.LANGUAGE.OTHER',
};
